import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="not-found-page min-h-screen flex items-center justify-center bg-gray-50">
      <div className="container mx-auto px-4 text-center">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-9xl font-bold text-[#5c0701] mb-4">404</h1>
          <h2 className="text-4xl font-bold mb-6">Page Not Found</h2>
          <p className="text-xl text-gray-600 mb-8">
            Sorry, the page you're looking for doesn't exist or has been moved.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="bg-[#3a87fe] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#2968d9] transition"
              data-testid="404-home-link"
            >
              Go Home
            </Link>
            <Link
              to="/contact"
              className="border-2 border-[#5c0701] text-[#5c0701] px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#5c0701] hover:text-white transition"
              data-testid="404-contact-link"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;